import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TimelineContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  TimelineContext.displayName = 'TimelineContext';
}

export default TimelineContext;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/Timeline/TimelineContext.js
// module id = 469
// module chunks = 121